import Commons from '../../../../Services/Common/Common';

export const M_TBG_CUSTOM_01_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid,
      TbmYn: (context) => Commons.EncryptAES(context.userInfo?.tbmYn) || '',
    },
    save1: {
      UserId: (_, context) => context.userInfo?.userid,
      CustCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.custCd) || '',
      VideoPath: () => Commons.EncryptAES('') || '',
      FilePath: () => Commons.EncryptAES('') || '',
      PlanPath: () => Commons.EncryptAES('') || '',
    },
    save2: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd) || '',
      EStep: (row) => Commons.EncryptAES(String(row.eStep ?? '')) || '',
      MStep: (row) => Commons.EncryptAES(String(row.mStep ?? '')) || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
    delete1: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd) || '',
    },
  },
};
